import { HttpClient } from '@angular/common/http';
import { Component, NgZone, OnInit } from '@angular/core';
import { AuthService } from 'app/_services';
import { LoaderService } from 'app/_services/loader.service';
import { environment } from 'environments/environment';
import { saveAs } from 'file-saver';
import { utils, write, WorkBook } from 'xlsx';  
import * as XLSX from 'xlsx';
import { async } from '@angular/core/testing';
declare var $: any;

@Component({
  selector: 'DoorToDoorComponent',
  templateUrl: './doorToDoor.component.html',
  styleUrls: ['./doorToDoor.component.css']
})


export class DoorToDoorComponent implements OnInit {
  public showLoader: boolean;
  public prjId: string;
  public data: any;
  public ddata:any;
  id: string;
  file: boolean;
  done: boolean;
  updateui: Object;


  constructor(private auth : AuthService,private http : HttpClient ,private loaderService: LoaderService,private _ngZone: NgZone)
  {
   this.loaderService.status.subscribe((val: boolean)=>{
   this.showLoader = val;
 });

} 
 
  ngOnInit() {
    this.prjId = this.auth.getAuthentication().projectId;
    this.id = this.auth.getAuthentication().id;
    this.getAllDTDdata();

  }
  getAllDTDdata() {
    this.loaderService.display(true); 
    this.http.get(environment.apiUrl + 'reports/getAllDTDCollection?PRJID='+this.prjId).subscribe(data =>{
        
          this.ddata     =     data
      

    });

    this.loaderService.display(false); 
    

  }


  // modal open  to insert excell data 
  insertExcell(){
  $("#uploadModal").modal("show");


  }


  importDoorToDoorExcelReport(data){
    const ws_name = 'DoorTODoorReport';
    const wb: WorkBook = { SheetNames: [], Sheets: {} };
    const ws: any = utils.json_to_sheet(this.data);
    wb.SheetNames.push(ws_name);
    wb.Sheets[ws_name] = ws;
    const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type:'binary' });
   saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'exported.xlsx');
  }
  s2ab(s){
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; ++i) {
        view[i] = s.charCodeAt(i) & 0xFF;
      };
      return buf;
    }
  

    /// Excell code #atul

    onFileChange(evt:any) {
      const target : DataTransfer =  <DataTransfer>(evt.target);
      if (target.files.length !== 1) throw new Error('Cannot use multiple files');
 
      const reader: FileReader = new FileReader();
      reader.onload = (e: any) => {
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname : string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
      let x = this.data.slice(1);
     
 
      //console.log(jasondata);
 
    };
 
     reader.readAsBinaryString(target.files[0]);
 
   }

   async saveExcellData(){
      
       
    let text = "are you sure to upload right file to save data ";
    if (confirm(text) == true) {
      text = "You pressed OK!";
      var jasondata = this.data  
      var finaljasondata =[]
      var len = jasondata.length
  
      for(var i = 2; i <len; i++) {
          
        finaljasondata.push({
         ZoneNumber:jasondata[i][1],
         WardNumber:jasondata[i][2],
         VehicleNumber:jasondata[i][3],
         RouteNumber:jasondata[i][4],
         NameOfArea:jasondata[i][5],
         MixedWate:jasondata[i][6],
         })
      } 
  
  
  
      
      var apidata = {
        'data':finaljasondata,
        'projId':this.prjId,
        'userId':this.id
      };
        
      console.log(text);
      $("#fileInput").val("");
      
          
      await    this.http.post(environment.apiUrl + 'reports/SaveDoorToDoorMixedWastData', apidata).toPromise().then(value =>{
      
        setTimeout(() => {
          this.file= true
          this.getAllDTDdata();
          $("#uploadModal").modal("hide");
          }, 10000); 
    
      })

    


    } else {
      text = "You canceled!";

    
      
    }

  
    this.file= false ;
   



    
   }






  /// Excell code #atul  End
  
}


// WEBPACK FOOTER //
// ./src/app/reports/doorToDoorMixedwaste/doorToDoor.component.ts